import React from "react";
import { Box, Stack, Typography, Button } from "@mui/material";
import ArrowBackIosOutlinedIcon from "@mui/icons-material/ArrowBackIosOutlined";
import AddIcon from "@mui/icons-material/Add";

const StickyHeader = ({ title, onBack, showButton = false, onButtonClick, rightContent, showBorder = true, showRightLabel = false, rightLabel = "", }) => (
    <Box
        sx={{
            position: "sticky",
            top: 0,
            zIndex: 100,
            paddingBottom: 1,
            paddingLeft: 2.5,
            paddingRight: 2.5,
            paddingTop: 1,
            height: "50px",
            backgroundColor: "#FFFFFF",
            display: "flex",
            justifyContent: "space-between", // left: title, right: button
            alignItems: "center",
            borderBottom: showBorder ? "1px solid #E5E7EB" : "none", 
        }}
    >
        {/* Left side: back + title */}
        <Stack direction="row" alignItems="center" spacing={2}>
            {onBack && (
                <ArrowBackIosOutlinedIcon
                    fontSize="small"
                    sx={{
                        color: "text.secondary",
                        cursor: "pointer",
                        width: "19px",
                        height: "19px",
                    }}
                    onClick={onBack}
                />
            )}
            <Typography
                variant="h5"
                sx={{ color: "#E7000B", fontSize: "16px", fontWeight: 600 }}
            >
                {title}
            </Typography>
        </Stack>

        {/* Right side: optional built-in button */}
        
        {/* Right side: can render custom content or fallback to built-in button */}
        <Stack direction="row" alignItems="center" spacing={2}>
            {showRightLabel && (
                <Typography
                    variant="body2"
                    sx={{
                        fontSize: "14px",
                        fontWeight: 500,
                        color: "text.secondary",
                    }}
                >
                    {rightLabel}
                </Typography>
            )}

            {rightContent || (
                showButton && (
                    <Button
                        variant="contained"
                        color="secondary"
                        startIcon={<AddIcon />}
                        onClick={onButtonClick}
                        sx={{
                            width: 118,
                            whiteSpace: "nowrap",
                            textTransform: "none",
                            mt: "3px",
                            "& .MuiButton-startIcon": {
                                mr: "2px",
                            },
                        }}
                    >
                        Create Issue
                    </Button>
                )
            )}
        </Stack>


    </Box>
);

export default StickyHeader;
